import { useEffect, useState } from "react";
import "./event-calendar.css";

import { MACHINES } from "./data/constants";
import { useWindowSize } from "./hooks/useWindowSize";
import { EventsFetchAPI } from "../../api/Events";
import Modal from "./components/Modal";
import EventDetail from "./components/EventDetail";
import CalendarHeader from "./components/CalendarHeader";
import CalendarGrid from "./components/CalendarGrid";
import UpcomingList from "./components/UpcomingList";
import CreateEventModal from "./components/CreateEventModal";
import { getRandomColor } from "../utils/RandomColor";
import { BranchOfficeFetchAPI } from "../../api/BranchOffices";
import AlertSmall from "../Alerts/AlertSmall";
import LoadingAlert from "../Alerts/LoadingAlert";

export default function EventCalendar({ events, setEvents, getEvents }) {
  const today = new Date();
  const { w } = useWindowSize();
  const mobile = w < 640;
  let token = localStorage.getItem('x-access-token');
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [branchOfficesData, setBranchOfficesData] = useState([]);

  const getbranchofficeByBusiness = async () => {
    let user = JSON.parse(localStorage.getItem('user'));
    let token = localStorage.getItem('x-access-token');
    try {
      const response = await BranchOfficeFetchAPI.getBranchOfficesByBusiness(user.business_id, token);
      let dataResponse = response.data.data;
      let branchOfficeArray = []
      dataResponse.forEach((branch) => {
        branchOfficeArray.push({ id: branch.branchofficeId, name: branch.branchofficeName, address: "", icon: "🏢", color: getRandomColor() })
      })
      setBranchOfficesData(branchOfficeArray);
    } catch (error) {
      console.log(error);
    }
  }

  /*const [events, setEvents] = useState([
    {
      id: "1",
      name: "Mantenimiento CNC",
      start: new Date(2026, 1, 9),
      end: new Date(2026, 1, 12),
      branches: ["b1", "b2"],
      branchMachines: { b1: ["m1", "m2"], b2: ["m3"] },
      description: "Mantenimiento preventivo trimestral.",
      notes: "Requiere piezas de repuesto.",
    },
    {
      id: "2",
      name: "Producción Lote #47",
      start: new Date(2026, 1, 16),
      end: new Date(2026, 1, 20),
      branches: ["b1"],
      branchMachines: { b1: ["m3", "m4"] },
      description: "Corte láser y prototipado 3D.",
      notes: "",
    },
    {
      id: "3",
      name: "Capacitación soldadura",
      start: new Date(2026, 1, 23),
      end: new Date(2026, 1, 25),
      branches: ["b3"],
      branchMachines: { b3: ["m6"] },
      description: "Entrenamiento del equipo nuevo.",
      notes: "Confirmar asistencia.",
    },
  ]);*/

  const TOTAL_STEPS = 5;

  const [showCreate, setShowCreate] = useState(false);
  const [step, setStep] = useState(0);
  const [selectEventToUpdate, setSelectEventToUpdate] = useState(null);
  const [type, setType] = useState("new");
  const [newEvent, setNewEvent] = useState({
    name: "",
    description: "",
    start: null,
    end: null,
    branches: [],
    branchMachines: {},
    notes: "",
  });

  const [rangePM, setRangePM] = useState(today.getMonth());
  const [rangePY, setRangePY] = useState(today.getFullYear());
  const [hovered, setHovered] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);


  //get information event 
  const getEventDetaills = async (event, res) => {

    console.log("Consulta evento ahora", event);
    const branch = await getBranchofficeByEvent(event.id);
    const machines = await getMachinesByEvent(event.date_id);

    let branchFormat = []
    let machinesFormat = {}

    if (branch?.data?.branchoffices) {
      branch.data.branchoffices.forEach(b => {
        branchFormat.push(b.branchoffice_id)
      });
    }

    if (machines?.data?.machines) {
      machines.data.machines.forEach(m => {
        if (!machinesFormat[m.branchoffice_id]) machinesFormat[m.branchoffice_id] = [];
        machinesFormat[m.branchoffice_id].push(m.id);
      })
    }
    event.branches = branchFormat;
    event.branchMachines = machinesFormat;

    console.log(event);

    if(res) return event;

    setSelectedEvent(event)

  }

  const getBranchofficeByEvent = async (event_id) => {
    try {
      const response = await EventsFetchAPI.getbranchofficeByEvent(event_id, token);
      return response;
    } catch (error) {
      return null
    }
  }

  const getMachinesByEvent = async (event_date_id) => {
    try {
      const response = await EventsFetchAPI.getMachinesByEvent(event_date_id, token);
      return response;
    } catch (error) {
      return null
    }
  }

  const assingnMachinesToEvent = async (event_date_id, branchMachines) => {
    const allMachines = Object.values(branchMachines).flat();
    try {
      const response = await EventsFetchAPI.assignMachinestoEvent({ event_date_id: event_date_id, machines: allMachines }, token);
    } catch (error) {
      console.log(error);
    }
  }

  function formatDateToYMD(date) {
    return date.toISOString().slice(0, 10);
  }

  const assignDateToEvent = async (event_id) => {
    try {

      let data = {
        "initialDate": formatDateToYMD(newEvent.start) + 'T00:00:00.000+00:00',
        "maxDate": formatDateToYMD(newEvent.end) + 'T23:59:59.000+00:00',
        "public": newEvent.public && newEvent.public !== "" ? newEvent.public : 0,
        "description": newEvent.description,
      }
      const response = await EventsFetchAPI.assigndatetoevent(event_id, data, token);
      getEvents();
      //getEventById(event_id);
      setShowCreate(false);

    } catch (error) {
      console.log(error);
    }
  }

  //create event request
  const createEventRequest = async () => {
    if (type === "new") {
      let user = JSON.parse(localStorage.getItem('user'));
      try {
        //format data to send to the backend
        let data = {
          "name": newEvent.name,
          "description": newEvent.description,
          "initialDate": formatDateToYMD(newEvent.start) + 'T00:00:00.000+00:00',
          "maxDate": formatDateToYMD(newEvent.end) + 'T23:59:59.000+00:00',
          "business_id": user.business_id,
          "public": 10,
          "branchoffices": newEvent.branches
        }
        //send data to the backend
        const response = await EventsFetchAPI.createEvent(data, token);
        LoadingAlert("Creando evento...", "Espere mientras se crea el evento");
        //await assingnMachinesToEvent(response.data.event_id, newEvent.branchMachines);
        getEvents()
        getEventById(response.data.event_id);
        setShowCreate(false);
        AlertSmall({ message: "Evento creado exitosamente", type: "success" });
      } catch (error) {
        console.log(error);
      }
    } else {
      assignDateToEvent(selectEventToUpdate.id);
    }
  }


  const getEventById = async (event_id) => {
    try {
      const response = await EventsFetchAPI.getEventById(event_id, token);
      console.log(response.data);
      let date_id = response.data.event[0].dates[0].id;

      await assingnMachinesToEvent(date_id, newEvent.branchMachines);

    } catch (error) {
      console.log(error);
    }
  }
  //--------------------------------------

  const openCreate = () => {
    setNewEvent({ name: "", description: "", start: null, end: null, branches: [], branchMachines: {}, notes: "" });
    setStep(0);
    setRangePM(currentMonth);
    setRangePY(currentYear);
    setHovered(null);
    setShowCreate(true);
  };

  const nextStep = () => setStep((s) => Math.min(s + 1, TOTAL_STEPS - 1));
  const prevStep = () => setStep((s) => Math.max(s - 1, 0));

  const canNext = () => {
    console.log(type);
    if (step === 0 && type === "existing") return selectEventToUpdate !== null; console.log("Data", selectEventToUpdate);
    if (step === 0 && type === "new") return newEvent.name.trim().length > 0;
    if (step === 1) return newEvent.start && newEvent.end;
    if (step === 2) return newEvent.branches.length > 0;
    if (step === 3) return Object.values(newEvent.branchMachines).flat().length > 0;
    return true;
  };

  const createEvent = () => {
    createEventRequest();
    //setEvents([...events, { ...newEvent, id: Date.now().toString() }]);
    //setShowCreate(false);
  };

  const saveEvent = (u) => {
    setEvents(events.map((e) => (e.id === u.id ? u : e)));
    setSelectedEvent(u);
  };

  const deleteEvent = (id) => {
    setEvents(events.filter((e) => e.id !== id));
    setSelectedEvent(null);
  };

  const prevMonth = () => {
    if (currentMonth === 0) { setCurrentMonth(11); setCurrentYear(currentYear - 1); }
    else setCurrentMonth(currentMonth - 1);
  };

  const nextMonth = () => {
    if (currentMonth === 11) { setCurrentMonth(0); setCurrentYear(currentYear + 1); }
    else setCurrentMonth(currentMonth + 1);
  };

  const goToday = () => {
    setCurrentMonth(today.getMonth());
    setCurrentYear(today.getFullYear());
  };

  const getEventColor = (ev) => {
    const allM = Object.values(ev.branchMachines || {}).flat();
    if (allM.length > 0) {
      const m = MACHINES.find((x) => x.id === allM[0]);
      if (m) return m.color;
    }
    return "#3B82F6";
  };


  useEffect(() => { getbranchofficeByBusiness(); }, []);

  return (
    <div className="ec-app">
      <CalendarHeader
        mobile={mobile}
        currentMonth={currentMonth}
        currentYear={currentYear}
        onPrev={prevMonth}
        onNext={nextMonth}
        onToday={goToday}
        onCreate={openCreate}
      />

      <CalendarGrid
        mobile={mobile}
        today={today}
        currentMonth={currentMonth}
        currentYear={currentYear}
        events={events}
        onSelectEvent={getEventDetaills}
        getEventColor={getEventColor}
        getEventDetaills={getEventDetaills}
      />

      <UpcomingList
        mobile={mobile}
        events={events}
        today={today}
        onSelectEvent={getEventDetaills}
        getEventColor={getEventColor}
        branchOfficesData={branchOfficesData}
      />

      <CreateEventModal
        open={showCreate}
        events={events}
        onClose={() => setShowCreate(false)}
        mobile={mobile}
        step={step}
        totalSteps={TOTAL_STEPS}
        newEvent={newEvent}
        setNewEvent={setNewEvent}
        hovered={hovered}
        setHovered={setHovered}
        rangePM={rangePM}
        rangePY={rangePY}
        setRangePM={setRangePM}
        setRangePY={setRangePY}
        canNext={canNext}
        nextStep={nextStep}
        prevStep={prevStep}
        onCreate={createEvent}
        branchOfficesData={branchOfficesData}
        setBranchOfficesData={setBranchOfficesData}
        setSelectEventToUpdate={setSelectEventToUpdate}
        selectEventToUpdate={selectEventToUpdate}
        type={type}
        setType={setType}
      />

      <Modal open={!!selectedEvent} onClose={() => setSelectedEvent(null)} width={520}>
        {selectedEvent && (
          <EventDetail
            event={selectedEvent}
            onClose={() => setSelectedEvent(null)}
            onSave={saveEvent}
            getEvents={getEvents}
            onDelete={deleteEvent}
            getEventDetaills={getEventDetaills}
            branchOfficesData={branchOfficesData}
            setBranchOfficesData={setBranchOfficesData}
            setSelectedEvent={setSelectedEvent}
          />
        )}
      </Modal>
    </div>
  );
}
